// redux/selectors/litshieldSelectors.ts
import { RootState } from "../../redux/storeTypes";


export const selectScopeAccess = (scope: string) => (state: RootState) =>
  Boolean(state.litshield.scopes[scope]?.access_granted);

export const selectScopeExpiresAt = (scope: string) => (state: RootState) =>
  state.litshield.scopes[scope]?.expires_at || null;

export const selectScopePinRequired = (scope: string) => (state: RootState) =>
  state.litshield.scopes[scope]?.pin_security_enabled ?? true;


export const selectRemainingSecondsForScope = (scope: string) => (state: RootState) => {
  const expiresAt = state.litshield.scopes[scope]?.expires_at;
  if (!expiresAt) return null;
  const expires = new Date(expiresAt).getTime();
  const now = Date.now();
  const diffSeconds = Math.floor((expires - now) / 1000);
  return diffSeconds > 0 ? diffSeconds : 0;
};
